import { Box, styled } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { Trustpilot } from './Trustpilot';
import { AboutSlide, RandomSlide } from './AboutSlider';
import { memo, useMemo } from 'react';
import paymentsVideo from './assets/payments.mp4';
import cardsVideo from './assets/cards.mp4';
import exchangeVideo from './assets/exchange.mp4';
import payrollVideo from './assets/payroll.mp4';

const AboutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  background: '#000',
  padding: theme.spacing(8),
  paddingTop: theme.spacing(16),
}));

export const AuthAbout = memo(function AuthAbout() {
  const { t } = useTranslation();

  const slides = useMemo(
    (): AboutSlide[] => [
      {
        key: 'payments',
        title: t('Global payments,\none dashboard'),
        video: paymentsVideo,
      },
      {
        key: 'cards',
        title: t('Multi‑currency\nBrighty Business Card'),
        video: cardsVideo,
      },
      {
        key: 'exchange',
        title: t('Seamless FX for Fiat\n& Crypto balances'),
        video: exchangeVideo,
      },
      {
        key: 'payroll',
        title: t('Run Crypto & Fiat\nPayroll to 180+ countries'),
        video: payrollVideo,
      },
    ],
    [t],
  );

  return (
    <AboutContainer>
      <RandomSlide slides={slides} />
      <Trustpilot companies={150} turnover="$300M" />
    </AboutContainer>
  );
});
